export default __webpack_public_path__ + "static/media/html5.149fc1ba.png";